import { useLingui } from "@lingui/react/macro";
import { useFormContext, type FieldValues } from "react-hook-form";
import Checkboxes from "@/components/Checkbox/Checkboxes";
import Checkbox from "@/components/Checkbox/Checkbox";
import {
  measurementsDictionary,
  orderedMeasurementsList,
} from "@medoma/models/activities";
import {
  useFieldPathWithPrefix,
  useFieldErrorWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import { useIsInFinalValidationPhase } from "@/pages/template-manager/TemplateFieldValidationContext";
import type { TemplateMeasurementsPickerFields } from "@/pages/template-manager/TemplateForm/templateFormSchema";

export const TemplateMeasurementsPicker = () => {
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();
  const { t } = useLingui();

  const fieldName =
    useFieldPathWithPrefix<TemplateMeasurementsPickerFields>("measurements");
  const errorMessage =
    useFieldErrorWithPrefix<TemplateMeasurementsPickerFields>(
      errors,
      "measurements",
    );
  const isInFinalValidationPhase = useIsInFinalValidationPhase();

  return (
    <Checkboxes
      legend={t`Värden`}
      errorMessage={errorMessage}
      orientation="horizontal"
    >
      {orderedMeasurementsList.map((measurement) => {
        return (
          <Checkbox
            key={measurement}
            label={{ text: t(measurementsDictionary[measurement]) }}
            {...register(fieldName, {
              required: isInFinalValidationPhase
                ? {
                    value: true,
                    message: t`Ange minst ett mätvärde`,
                  }
                : undefined,
            })}
            value={measurement}
            visualStyle="framed"
          />
        );
      })}
    </Checkboxes>
  );
};
